import { useQuery } from '@apollo/client';
import { GET_EMPLOYEE } from '@src/graphql/queries/employee';
export const useGetEmployee = ({ employeeId }) => {
    const { data, error, loading } = useQuery(GET_EMPLOYEE, {
        variables: { id: employeeId },
        skip: !employeeId,
    });
    const employee = data?.getEmployee;
    return {
        employee,
        error,
        loading,
    };
};
